// We get these values from the external stores, so they can't be changed unless they change also on the stores

const enum ProductStockStatusEnum {
  InStock = 'IN_STOCK',
  OutOfStock = 'OUT_OF_STOCK',
  ComingSoon = 'COMING_SOON',
  PreOrder = 'PRE_ORDER',
  BackOrder = 'BACKORDER',
  SoldOut = 'SOLD_OUT',
  DoNotShow = 'DO_NOT_SHOW',
  BtoBOnly = 'B2B_ONLY',
}

export default ProductStockStatusEnum;
